import React from 'react';
import { motion } from 'framer-motion';
import { families } from '../../data/bookData';
import SectionHeading from '../SectionHeading';

const FamiliesTeaser = () => (
  <section className="py-24 bg-brand-dark relative border-t border-white/5">
    <div className="max-w-6xl mx-auto px-6 lg:px-8">
      <SectionHeading title="The Lineages" subtitle="Multi-Generational" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {families.map((family, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="bg-brand-surface border border-white/5 rounded-2xl p-6 hover:border-white/10 transition-colors group"
          >
            <div className={`text-xs font-semibold uppercase tracking-widest mb-3 ${family.accent}`}>{family.origin}</div>
            <h3 className="text-white font-display font-bold text-lg mb-3 group-hover:text-brand-accent transition-colors">{family.name}</h3>
            <p className="text-gray-500 text-sm leading-relaxed">{family.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default FamiliesTeaser;